// Constants
import {
  ACCOUNT_REPORTS,
  ERROR,
  REPORTS,
  TINK_ORIGIN,
} from './constants/identification.utils.constants';

const eventIsNotFromTink = (origin: string): boolean => origin !== TINK_ORIGIN;

const isErrorType = (type: string): boolean => type === ERROR;

const isReportsType = (type: string): boolean => type === REPORTS;

const isAccountReportType = (type: string): boolean => type === ACCOUNT_REPORTS;

export { eventIsNotFromTink, isAccountReportType, isErrorType, isReportsType };
